<template>
    <div style="position: relative">
        <vs-button radius icon-pack="feather" size="large" icon="icon-save" @click="mergeAssets" :class="{'pen': isLoading }" class="fixed-button save" id="save-asset-btn"  v-if="$store.state.user.role.name === 'Manager'" />
        <vs-button radius icon-pack="feather" color="success" size="large" icon="icon-plus" class="fixed-button delete" @click="isAddRelatedAsset = true" v-if="$store.state.user.role.name === 'Manager'"/>
        <div class="merge-container">
            <div :class="{'active': main_asset && main_asset.id === item.id}" class="merge-item" v-for="(item, index) in related_assets" :key="index" @click="selectMainItem(item)">
                <view-merge-asset :asset="item" v-on:removeSelectedAsset="removeSelectedAsset" ></view-merge-asset>
            </div>
        </div>
        <add-related-assets v-if="isAddRelatedAsset" v-on:close="isAddRelatedAsset = false"
                            v-on:addRelatedAssets="addRelatedAssets"
                            :relatedAssets="related_assets"></add-related-assets>
        <error404 v-if="isError" :is_page="true"></error404>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import 'swiper/dist/css/swiper.min.css'
    import addRelatedAssets from '../components/modal/addRelatedAssets.vue'
    import ViewMergeAsset from './ViewMergeAsset.vue'


    export default {
        name: 'MergeAsset',
        components: {
            addRelatedAssets,
            vSelect,
            ViewMergeAsset,
        },
        head: {
            title() {
                return {
                    inner: 'AMP',
                    separator: this.header_separator,
                    complement: this.header_component
                }
            },
            meta: [
                {hid: 'description', name: 'description', content: ''}
            ]
        },
        data() {
            return {
                debounce: false,
                isError: false,
                isLoading: false,
                header_separator: ' ',
                header_component: '',
                isAddRelatedAsset: false,
                related_assets: [],
                main_asset: null
            }
        },
        mounted() {
            if (this.$store.state.user.role.name !== 'Manager') {
                this.$router.push('/');
            }
        },
        methods: {
            updateHead() {
                this.header_component = this.asset.title
                this.header_separator = '-'
                this.$emit('updateHead')
            },
            addRelatedAssets(data) {
                if (data) {
                    data.forEach(item => {
                        if (this.related_assets.findIndex(el => el.id === item.id) === -1) {
                            this.$axios.get('/assets/' + item._id).then(res => {
                                this.related_assets.push(res.data)
                            })

                        }
                    })
                }
            },
            closeAddRelatedAssets() {
                this.isAddRelatedAsset = false;
            },
            selectMainItem(item) {
                this.main_asset = item
            },
            removeSelectedAsset(data) {
                let index = this.related_assets.findIndex(el => el.id == data.id);
                if (index != -1) {
                    if (this.main_asset && data.id == this.main_asset.id) {
                        this.main_asset = null
                    }
                    this.related_assets.splice(index, 1);
                }
            },
            mergeAssets() {
                if (this.main_asset) {
                    if (this.related_assets.length > 1) {
                        this.$root.addLoading('#edit-asset-update-btn');
                        let url = '/merge-assets';
                        let relatedIds = [];
                        for (let k in this.related_assets) {
                            if (this.related_assets[k].id != this.main_asset.id) {
                                relatedIds.push(this.related_assets[k].id);
                            }
                        }

                        let data = {
                            main_id: this.main_asset.id,
                            related_ids: relatedIds
                        }

                        this.$axios.post(url, data)
                            .then(res => {
                                this.$root.removeLoading('#edit-asset-update-btn');

                                this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully merged'})

                                this.$router.push(`/${this.main_asset.id}`)
                            }).catch(e => {
                                console.log(e);
                                this.$root.removeLoading('#edit-asset-update-btn');
                                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Something wrong'})
                            })
                    } else {
                        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Select more then 1 asset'})
                    }
                } else {
                    this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Select primary asset'})
                }
            }
        },
        computed: {},
        watch: {},
    }
</script>
